import { Salad, Leaf, Sprout, Carrot, Apple, Cherry, Waves, Vegan, Nut, Warehouse, Building2, Container, Fish, Droplets, Zap, Recycle, Wind, FlaskConical, Boxes, Layers, Grid3x3, Sun } from "lucide-react";

export const CROP_ICONS = { "Leafy Greens": Salad, "Culinary Herbs": Leaf, "Microgreens": Sprout, Carrots: Carrot, Tomato: Apple, Strawberries: Cherry, Macroalgae: Waves, Microalgae: Waves, Mushrooms: Vegan, Potatoes: Nut };
export const cropIcon = (crop) => CROP_ICONS[crop.group] || Sprout;

// Unified BIA iconography (Section 9) — tasteful lucide icons for systems, resources & zones
export const systemIcon = (s) => {
  const t = `${s.group || ""} ${s.label || ""}`.toLowerCase();
  if (/vertical|indoor|warehouse/.test(t)) return Warehouse;
  if (/aquapon|aqua|fish|tank/.test(t)) return Fish;
  if (/greenhouse/.test(t)) return Sprout;
  if (/hydro|pod|modular|container/.test(t)) return Container;
  if (/roof/.test(t)) return Building2;
  if (/bed|soil|raised|substrate/.test(t)) return Sprout;
  return Boxes;
};
export const resourceIcon = (r) => {
  const t = `${r.category || ""} ${r.label || ""}`.toLowerCase();
  if (/water|rain|grey|irrig/.test(t)) return Droplets;
  if (/energy|solar|power|pv|electric/.test(t)) return Zap;
  if (/co2|air|carbon/.test(t)) return Wind;
  if (/heat|therm/.test(t)) return FlaskConical;
  if (/waste|compost|organic|nutrient|digest/.test(t)) return Recycle;
  return Recycle;
};
export const locationIcon = (l) => {
  const t = `${l.label || ""}`.toLowerCase();
  if (/roof/.test(t)) return Building2;
  if (/facade|wall/.test(t)) return Layers;
  if (/ground|plaza|yard|court/.test(t)) return Grid3x3;
  if (/interior|indoor|basement/.test(t)) return Warehouse;
  return Sun;
};
